import { COLORS } from '@/constants/colors';
import theme from '@/utils/theme';

export const classes = {
  root: {
    backgroundColor: theme.palette.background.default,
    boxShadow: 'none',
    py: '10px',
    position: 'relative'
  },
  logoText: {
    flexGrow: { xs: 1, md: 0 },
    fontWeight: 800,
    fontSize: {
      xs: '16px',
      sm: '24px'
    },
    color: theme.palette.text.primary,
    textDecoration: 'none'
  },
  justifyBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  menuIcon: {
    display: { md: 'none' },
    color: {
      xs: theme.palette.text.primary,
      md: theme.palette.primary.main
    }
  },
  drawer: {
    display: { xs: 'block', md: 'none' },
    '& .MuiDrawer-paper': {
      boxSizing: 'border-box',
      maxWidth: 320,
      width: '100%'
    }
  },
  getStartedBtn: {
    ml: 1,
    py: {
      xs: '10px'
    }
  },
  navItem: {
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent'
    }
  },
  iconBox: {
    height: '48px',
    width: '48px',
    border: `1px solid ${COLORS.borderColor}`,
    borderRadius: 2,
    mr: 3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};
